import { Navigate } from "react-router-dom";

function AdminGuard({ children }) {
  const userType = localStorage.getItem("userType");
  if (userType !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export default AdminGuard;
